import './user-header.scss';

import React, {
    useEffect,
    useState,
} from 'react';

import { LogoutButton } from './logout-button/logout-button';

import {
    SessionManager,
} from '../../utilities/session-management/session-manager';

import {
    JegerwebApiService,
} from '../../services/api-service/jegerweb-api-service';

interface Jegerdata {
    jeger?: {
        navn?: string;
    };
}

export const UserHeader: React.FC = () => {
    const [isReady, setReady] =
        useState(false);

    const [jegerdata, setJegerdata] =
        useState<Jegerdata>({});

    useEffect(() => {
        const session =
            SessionManager.session;

        if (!session) {
            return;
        }

        setReady(
            session.isReady(),
        );

        session.addReadyChangeListener(
            (ready: boolean) => {
                setReady(ready);
            },
        );
    }, []);

    useEffect(() => {
        if (!isReady) {
            return;
        }

        JegerwebApiService.get(
            '/jeger/:sessiontype/navn',
        )
            .then((response) => {
                if (
                    response.data &&
                    response.data.jeger
                ) {
                    setJegerdata(
                        response.data,
                    );
                } else if (response.data) {
                    setJegerdata({
                        jeger: {
                            navn:
                            response.data,
                        },
                    });
                } else {
                    setJegerdata({
                        jeger: {
                            navn:
                                'Ukjent',
                        },
                    });
                }
            })
            .catch(() => {
                setJegerdata({
                    jeger: {
                        navn:
                            'Feil ved lasting',
                    },
                });
            });
    }, [isReady]);

    if (!isReady) {
        return null;
    }

    return (
        <header className="user-header no-print">
            <div className="user-header__inner center">
                <p className="user-header__fullname">
                    {jegerdata?.jeger?.navn ||
                        'Laster...'}
                </p>

                <LogoutButton />
            </div>
        </header>
    );
};
